// app/javascript/controllers/tabs_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "content", "icon"]
  
  initialize() {
    this.showContentForTab(0)
    this.updateTabClasses(0)
    this.handleFormValidation()
  }
  
  connect() {
    const currentTab = sessionStorage.getItem("currentTab")
    const index = currentTab ? parseInt(currentTab) : 0
    this.showContentForTab(index)
    this.updateTabClasses(index)
  }

  switchTab(event) {
    event.preventDefault()
    const index = parseInt(event.currentTarget.dataset.index)
    sessionStorage.setItem("currentTab", index)
    this.showContentForTab(index)
    this.updateTabClasses(index)
    const currentTabField = document.getElementById("current_tab")
    if (currentTabField) {
      currentTabField.value = index
    }
  }

  showContentForTab(index) {
    this.contentTargets.forEach((content, idx) => {
      content.classList.toggle("hidden", idx != index)
      
      // Désactiver la validation pour les onglets cachés
      if (idx != index) {
        this.disableValidationForContent(content)
      } else {
        this.enableValidationForContent(content)
      }
    })
    
    // Redimensionner Mapbox si on affiche l'onglet géolocalisation (index 1)
    if (index === 1) {
      this.resizeMapbox()
    }
  }

  // Désactiver la validation pour les champs d'un contenu caché
  disableValidationForContent(content) {
    const requiredFields = content.querySelectorAll('[required]')
    requiredFields.forEach(field => {
      // Stocker l'état "required" original
      field.dataset.wasRequired = true
      field.removeAttribute('required')
    })
  }

  // Réactiver la validation pour les champs d'un contenu affiché
  enableValidationForContent(content) {
    const previouslyRequiredFields = content.querySelectorAll('[data-was-required]')
    previouslyRequiredFields.forEach(field => {
      field.setAttribute('required', '')
    })
  }

  // Gérer la validation du formulaire
  handleFormValidation() {
    const form = this.element.closest('form')
    if (!form) return

    form.addEventListener('submit', (event) => {
      let hasErrors = false
      let firstErrorTabIndex = null
      
      // Vérifier chaque onglet pour les erreurs
      this.contentTargets.forEach((content, idx) => {
        // Temporairement rendre visible et activer la validation
        const wasHidden = content.classList.contains('hidden')
        if (wasHidden) {
          content.classList.remove('hidden')
          this.enableValidationForContent(content)
        }
        
        // Vérifier si des champs sont invalides
        const invalidFields = content.querySelectorAll(':invalid')
        if (invalidFields.length > 0 && firstErrorTabIndex === null) {
          firstErrorTabIndex = idx
          hasErrors = true
        }
        
        // Remettre l'état précédent
        if (wasHidden) {
          content.classList.add('hidden')
          this.disableValidationForContent(content)
        }
      })
      
      // S'il y a des erreurs, afficher l'onglet correspondant
      if (hasErrors && firstErrorTabIndex !== null) {
        event.preventDefault()
        event.stopPropagation()
        this.showContentForTab(firstErrorTabIndex)
        this.updateTabClasses(firstErrorTabIndex)
        sessionStorage.setItem("currentTab", firstErrorTabIndex)
        
        // Mettre le focus sur le premier champ invalide
        const firstInvalidField = this.contentTargets[firstErrorTabIndex].querySelector(':invalid')
        if (firstInvalidField) {
          firstInvalidField.focus()
        }
      }
    })
  }

  updateTabClasses(index) {
    this.tabTargets.forEach((tab, idx) => {
      const icons = this.hasIconTarget ? this.iconTargets.filter(icon => parseInt(icon.dataset.iconIndex) === idx) : []
      const icon = icons.length > 0 ? icons[0] : null
      
      if (idx == index) {
        tab.classList.add("text-bgadminlight", "border-b-2", "border-surfacerouge", "active", "font-bold", "text-base")
        tab.classList.remove("hover:text-gray-300", "hover:border-gray-300", "border-transparent", "font-normal", "text-sm")
        tab.setAttribute("aria-current", "page")
        
        if (icon) {
          icon.classList.remove("text-gray-400", "group-hover:text-gray-300")
          icon.classList.add("text-surfacerouge")
        }
      } else {
        tab.classList.remove("text-bgadminlight", "border-b-2", "border-surfacerouge", "active", "font-bold", "text-base")
        tab.classList.add("hover:text-gray-300", "hover:border-gray-300", "border-transparent", "font-normal", "text-sm")
        tab.removeAttribute("aria-current")
        
        if (icon) {
          icon.classList.add("text-gray-400", "group-hover:text-gray-300")
          icon.classList.remove("text-surfacerouge")
        }
      }
    })
  }

  resizeMapbox() {
    setTimeout(() => {
      const geocoderElement = document.querySelector('[data-controller*="organization-geocoder"]')
      if (geocoderElement) {
        const geocoderController = this.application.getControllerForElementAndIdentifier(
          geocoderElement, 
          "organization-geocoder"
        )
        
        if (geocoderController && geocoderController.map) {
          geocoderController.map.resize()
        }
      }
    }, 100)
  }
}